import { AxiosResponse } from "axios";
import { BookingMapper } from "@/data/persistences/mappers/BookingMapper";
import {
  EstimationPrice,
  // BookingVoucherList,
  // BookingVoucherItem,
  PosterProduct
} from "@/domain/entities/Booking";
import { ResponsePayload } from "@/domain/entities/ResponsePayload";
import {
  ExchangeRateBookingV4,
  SavedPackageBookingV4,
  SavedPackagePieceBookingV4
} from "@/domain/entities/BookingV4";

// BookingV4Mapper — clone/delegate BookingMapper sementara untuk response existing
export class BookingV4Mapper {
  private delegate = new BookingMapper();

  public convertPayloadData(res: AxiosResponse<any>): ResponsePayload {
    return this.delegate.convertPayloadData(res);
  }

  public convertEstimationPrice(res: AxiosResponse<any>): EstimationPrice {
    const estimationPrice = this.delegate.convertEstimationPrice(res);
    const data = res.data?.data;
    estimationPrice.finalPrice =
      data?.final_price ??
      data?.total_tariff_after_discount ??
      data?.total_tariff ??
      0;
    return estimationPrice;
  }

  /*
  public convertBookingVoucherList(
    res: AxiosResponse<any>
  ): BookingVoucherList {
    return this.delegate.convertBookingVoucherList(res);
  }

  public convertBookingVoucherItem(item: any): BookingVoucherItem {
    return this.delegate.convertBookingVoucherItem(item);
  }
  */

  // GENESIS-19593 — isRecommended wajib eksplisit: delegate V3 hanya
  // spread `is_recommended` (snake_case) mentah, parent GENESIS-20159
  // consume camelCase (parity V3 create-booking-manual.vue)
  public convertPosterProductDataFromApi(
    res: AxiosResponse<any>
  ): PosterProduct[] {
    const products = this.delegate.convertPosterProductDataFromApi(res);
    return products.map(
      (product) =>
        new PosterProduct({
          ...product,
          isRecommended: Boolean((product as any).is_recommended)
        })
    );
  }

  // GENESIS-19589 — Est. CIPL exchange rate: expect 1 active row; empty -> null
  public convertActiveExchangeRate(
    res: AxiosResponse<any>
  ): ExchangeRateBookingV4 | null {
    const items = res.data?.data;
    if (!Array.isArray(items) || items.length === 0) return null;
    const item = items[0];
    return new ExchangeRateBookingV4({
      exchangeRateId: item.exchange_rate_id,
      exchangeRateFrom: item.exchange_rate_from,
      exchangeRateTo: item.exchange_rate_to,
      exchangeRate: Number(item.exchange_rate) || 0,
      exchangeRateStatus: String(
        item.exchange_rate_status || ""
      ).toLowerCase(),
      startDate: item.exchange_rate_start_date,
      endDate: item.exchange_rate_end_date
    });
  }

  // GENESIS-20970 — Saved package customer: order preserved dari server (no re-sort)
  public convertSavedPackageFromApi(
    res: AxiosResponse<any>
  ): SavedPackageBookingV4[] {
    const items = res.data?.data;
    if (!Array.isArray(items)) return [];
    return items.map(
      (item: any) =>
        new SavedPackageBookingV4({
          id: item.csp_id ?? item.id,
          commodityCode: item.csp_commodity_code,
          totalPieces: Number(item.csp_total_piece) || 0,
          totalGrossWeight: Number(item.csp_total_gross_weight) || 0,
          source: item.csp_source
        })
    );
  }

  // GENESIS-20970 — Saved package detail: rincian koli (pieces) untuk prefill
  public convertSavedPackageDetailFromApi(
    res: AxiosResponse<any>
  ): SavedPackageBookingV4 {
    const data = res.data?.data;
    if (!data) return new SavedPackageBookingV4();

    const pieces = Array.isArray(data.pieces)
      ? data.pieces.map(
          (item: any) =>
            new SavedPackagePieceBookingV4({
              grossWeight: Number(item.cspp_gross_weight) || 0,
              length: Number(item.cspp_length) || 0,
              width: Number(item.cspp_width) || 0,
              height: Number(item.cspp_height) || 0
            })
        )
      : [];

    return new SavedPackageBookingV4({
      id: data.csp_id ?? data.id,
      commodityCode: data.csp_commodity_code,
      pieces
    });
  }
}
